"use strict";

let lenis;

window.addEventListener("DOMContentLoaded", () => {
  // Burger Menu /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const TriggerButton = document.querySelector(".burger-menu");
  const mobileMenu = document.querySelector(".div__nav--mobile");
  const mobileLinks = document.querySelectorAll(".menu__nav--mobile a");

  if (TriggerButton && mobileMenu) {
    // Ouvrir / fermer avec le bouton burger
    TriggerButton.addEventListener("click", () => {
      mobileMenu.classList.toggle("menu--open");
      TriggerButton.classList.toggle("is-open");
      TriggerButton.setAttribute(
        "aria-expanded",
        mobileMenu.classList.contains("menu--open") ? "true" : "false",
      );
    });

    //  Fermer quand on clique sur un lien
    mobileLinks.forEach((link) => {
      link.addEventListener("click", () => {
        mobileMenu.classList.remove("menu--open");
        TriggerButton.classList.remove("is-open");
        TriggerButton.setAttribute("aria-expanded", "false");
      });
    });
  }

  // MENU STICKY QUI DISPARAIT //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const desktopMenu = document.querySelector("header .bloc__menu--desktop");
  if (desktopMenu) {
    let lastY = window.scrollY;
    let ticking = false;

    //  on ignore le hide/show pendant un scroll déclenché par un clic
    let lockUntil = 0;

    // Quand on clique un lien du menu (ancres), on force le menu visible + on lock
    document
      .querySelectorAll('header .bloc__menu--desktop a[href^="#"]')
      .forEach((a) => {
        a.addEventListener("click", () => {
          desktopMenu.classList.remove("is-hidden");
          lockUntil = Date.now() + 900; // ajuste (600–1200ms)
          lastY = window.scrollY; // évite un gros delta juste après
        });
      });

    const update = () => {
      const now = Date.now();
      const y = window.scrollY;
      const delta = y - lastY;

      const THRESHOLD = 10;

      // si lock actif: on garde visible, on met à jour lastY, et on sort
      if (now < lockUntil) {
        desktopMenu.classList.remove("is-hidden");
        lastY = y;
        ticking = false;
        return;
      }

      // si on est tout en haut, toujours visible
      if (y < 50) {
        desktopMenu.classList.remove("is-hidden");
        lastY = y;
        ticking = false;
        return;
      }

      if (Math.abs(delta) > THRESHOLD) {
        if (delta > 0) {
          desktopMenu.classList.add("is-hidden");
        } else {
          desktopMenu.classList.remove("is-hidden");
        }
        lastY = y;
      }

      ticking = false;
    };

    window.addEventListener(
      "scroll",
      () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true },
    );
  }

  // SMOOTH SCROLL + le scroll avec les liens ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (typeof Lenis !== "undefined") {
    lenis = new Lenis({
      duration: 1.2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    if (typeof ScrollTrigger !== "undefined") {
      lenis.on("scroll", ScrollTrigger.update);
    }

    // Désactive le smooth natif CSS quand Lenis est actif
    document.documentElement.classList.add("lenis");
  }

  // Click sur ancres => scroll via Lenis (ou fallback)
  {
    const OFFSET = 100; // équivalent à scroll-padding-top

    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener("click", (e) => {
        const href = a.getAttribute("href");
        const id = href && href.length > 1 ? href : null;
        const target = id ? document.querySelector(id) : null;
        if (!target) return;

        e.preventDefault();

        // Si Lenis est actif => smooth via Lenis
        if (lenis) {
          lenis.scrollTo(target, { offset: -OFFSET });
        } else {
          // fallback si Lenis n’est pas chargé
          const top =
            target.getBoundingClientRect().top + window.pageYOffset - OFFSET;
          window.scrollTo({ top, behavior: "smooth" });
        }
      });
    });
  }

  // NAV ACTIVE //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  {
    const OFFSET = 110;

    const headerLinks = Array.from(
      document.querySelectorAll('header a[href^="#"]'),
    ).filter((a) => a.getAttribute("href").length > 1);

    // On récupère toutes les sections qui ont un id ou un data-nav
    const observedSections = Array.from(
      document.querySelectorAll("section[id], section[data-nav]"),
    ).filter((section) => {
      const navTarget = section.dataset.nav || section.id;
      return (
        navTarget &&
        headerLinks.some((a) => a.getAttribute("href") === `#${navTarget}`)
      );
    });

    if (observedSections.length) {
      const setActive = (activeId) => {
        headerLinks.forEach((a) => a.classList.remove("is-active"));
        headerLinks
          .filter((a) => a.getAttribute("href") === activeId)
          .forEach((a) => a.classList.add("is-active"));
      };

      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((e) => e.isIntersecting)
            .sort(
              (a, b) => a.boundingClientRect.top - b.boundingClientRect.top,
            );

          if (visible.length) {
            const section = visible[0].target;
            const activeTarget = section.dataset.nav || section.id;
            setActive(`#${activeTarget}`);
          }
        },
        {
          root: null,
          rootMargin: `-${OFFSET}px 0px -60% 0px`,
          threshold: 0.01,
        },
      );

      observedSections.forEach((section) => observer.observe(section));

      if (location.hash) {
        setActive(location.hash);
      }
    }
  }

  // ANIM DES CARTES /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (typeof gsap !== "undefined") {
    if (typeof ScrollTrigger !== "undefined") {
      gsap.registerPlugin(ScrollTrigger);
    }

    const cards = gsap.utils.toArray(".section__2 .but");
    const stack = document.querySelector(".section__2 .content__but");
    const trigger = document.querySelector(".section__2 .but1");

    if (
      cards.length &&
      stack &&
      trigger &&
      typeof ScrollTrigger !== "undefined"
    ) {
      // rotations : but1 = -5deg, but2 = 0deg, but3 = 5deg, but4 = 10deg
      const rotations = [-3, 0, 3, 6];

      // état initial : but2/3/4 vraiment hors écran (en bas)
      gsap.set(cards.slice(1), { y: () => window.innerHeight });
      gsap.set(cards[0], { y: 0, rotation: rotations[0] });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger,
          start: "center center",
          pin: stack,
          pinSpacing: true,
          scrub: 0.6, // plus smooth que true => moins de lag
          anticipatePin: 1,
          end: () => "+=" + (cards.length - 1) * 500,
          // markers: true,
        },
      });

      // arrivée depuis le bas + rotation (sans opacity)
      cards.slice(1).forEach((card, i) => {
        tl.to(
          card,
          {
            y: 0,
            rotation:
              rotations[i + 1] ??
              rotations[rotations.length - 1] +
                (i + 1 - (rotations.length - 1)) * 5,
            duration: 1,
            ease: "none",
          },
          ">",
        );
      });

      // refresh resize (debounce pour éviter lag)
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
      });
    }

    // PARALLAX /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (typeof ScrollTrigger !== "undefined") {
      const mm = gsap.matchMedia();

      mm.add("(min-width: 1200px)", () => {
        gsap.to(".img1", {
          y: -1200,
          scrollTrigger: {
            trigger: ".section__parallax",
            scrub: true,
          },
        });

        gsap.to(".img2", {
          y: -900,
          scrollTrigger: {
            trigger: ".section__parallax",
            scrub: true,
          },
        });
      });
    }
  }

  // TEAM QUI S'AFFICHE ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  {
    const team = document.querySelector(".team");
    const nav = document.querySelector(".team__nav");
    if (!team || !nav) return;

    const persons = Array.from(team.querySelectorAll(".person"));
    if (!persons.length) return;

    // Crée UN seul titre (réutilisé et déplacé)
    const title = document.createElement("div");
    title.className = "bloc__title--h2";
    title.innerHTML = "<h2>L'équipe</h2>";

    // Réglages
    const AUTOPLAY_MS = 15000;
    const IDLE_MS = 60000;

    let currentIndex = 0;
    let intervalId = null;
    let idleTimeoutId = null;

    // Crée les boutons
    nav.innerHTML = "";
    const buttons = persons.map((person, index) => {
      const img = person.querySelector(".bloc__img img");
      const src = img?.getAttribute("src") || "";
      const alt = img?.getAttribute("alt") || `Personne ${index + 1}`;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.setAttribute("aria-label", `Afficher ${alt}`);

      const thumb = document.createElement("img");
      thumb.src = src;
      thumb.alt = alt;

      btn.appendChild(thumb);

      btn.addEventListener("click", () => {
        setActive(index);
        pauseAutoplayForIdle();
      });

      nav.appendChild(btn);
      return btn;
    });

    function setActive(index) {
      currentIndex = index;

      persons.forEach((p) => p.classList.remove("is-active"));
      buttons.forEach((b) => b.classList.remove("is-active"));

      const person = persons[currentIndex];
      person.classList.add("is-active");
      buttons[currentIndex].classList.add("is-active");

      const content = person.querySelector(".person__content");
      if (!content) return;

      // Met le titre en 1er dans person__content (juste au-dessus du p)
      content.insertAdjacentElement("afterbegin", title);

      // Place la nav sous person__content (pas dedans)
      content.insertAdjacentElement("afterend", nav);
    }

    function startAutoplay() {
      stopAutoplay();
      intervalId = setInterval(() => {
        setActive((currentIndex + 1) % persons.length);
      }, AUTOPLAY_MS);
    }

    function stopAutoplay() {
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
    }

    function pauseAutoplayForIdle() {
      stopAutoplay();
      if (idleTimeoutId) clearTimeout(idleTimeoutId);
      idleTimeoutId = setTimeout(startAutoplay, IDLE_MS);
    }

    // Init
    setActive(0);
    startAutoplay();
  }
});

//ANIM FAQ SMOOTH ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
document.querySelectorAll(".faq__item").forEach((item) => {
  const summary = item.querySelector("summary");
  const content = item.querySelector(".faq__content");

  summary.addEventListener("click", (e) => {
    e.preventDefault();

    const isOpen = item.hasAttribute("open");

    if (!isOpen) {
      item.setAttribute("open", "");
      item.classList.add("is-open");

      const fullHeight = content.scrollHeight;

      content.style.height = "0px";
      content.style.opacity = "0";
      content.style.transform = "translateY(-8px)";
      content.style.transition =
        "height 0.5s ease, opacity 0.5s ease, transform 0.5s ease";

      content.offsetHeight;

      content.style.height = fullHeight + "px";
      content.style.opacity = "1";
      content.style.transform = "translateY(0)";

      content.addEventListener(
        "transitionend",
        () => {
          content.style.height = "auto";
        },
        { once: true },
      );
    } else {
      item.classList.remove("is-open");

      const fullHeight = content.scrollHeight;

      content.style.height = fullHeight + "px";
      content.style.opacity = "1";
      content.style.transform = "translateY(0)";
      content.style.transition =
        "height 0.5s ease, opacity 0.5s ease, transform 0.5s ease";

      content.offsetHeight;

      content.style.height = "0px";
      content.style.opacity = "0";
      content.style.transform = "translateY(-8px)";

      content.addEventListener(
        "transitionend",
        () => {
          item.removeAttribute("open");
        },
        { once: true },
      );
    }
  });
});
